import { Box, Checkbox, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material"
import { useGridApiRef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBufferProductsAction, updateProductBranchAction } from "../asyncActions/productsActions";
import { setCategory, setTypeBranch } from "../store/bufferSlice";
import addAllBranch from "../service/addAllBranch";
import DataGridFullScreen from "../components/DataGridFullScreen";
import { useTranslation } from "react-i18next";

function ProductsBufferPage() {

    const {t} = useTranslation()

    const dispatch = useDispatch()

    const [error, setError] = useState(null)
    const defaultColumns = [
        {
            field: 'id',
            headerName: 'id',
            maxWidth: 50,
            flex: 1
        },
        {
            field: 'product',
            headerName: t('grid.product_name'),
            minWidth: 200,
            flex: 1
        },
        {
            field: 'unit_type',
            headerName: t('grid.unit_type'),
            maxWidth: 80,
            flex: 1
        }
    ];

    const {
        branchList,
        bufferList,
        dataLoad,
        dataUpdate,
        categoryList,
        selectedTypeBranch,
        selectedCategory,
        kitchenList
    } = useSelector(store => store.buffer)
    const [columns, setColumns] = useState(defaultColumns)

    useEffect(() => {
        const params = {
            branch_type: selectedTypeBranch,
            category_id: selectedCategory
        }
        dispatch(getBufferProductsAction(params))
    }, [selectedCategory, selectedTypeBranch])

    const rows = addAllBranch(bufferList)

    const branhColumns = branchList.map(el => {
        const buffer_column = {
            field: 'branch_buffer_' + el.branch_id,
            headerName: t('grid.max_stock'),
            minWidth: 100,
            type: 'number',
            editable: true,
            flex: 1,
        }
        const second_column = {
            field: 'branch_active_' + el.branch_id,
            headerName: t('grid.active'),
            minWidth: 100,
            flex: 1,
            renderCell: (params) => {
                return (
                    <>
                        {params.row[`branch_buffer_${el.branch_id}`] !== null &&
                            <Checkbox
                                checked={params.row[`branch_active_${el.branch_id}`]}
                                onClick={(e) => {
                                    const data = {
                                        product: +params.id,
                                        branch: +params.field.split('_')[2],
                                        is_active: e.target.checked,
                                    }
                                    dispatch(updateProductBranchAction(data))
                                }}
                            />
                        }
                    </>
                )
            }
        }

        return [buffer_column, second_column]
    }).map(el => el.flat()).flat()

    useEffect(() => {
        setColumns([...defaultColumns, ...branhColumns])
    }, [branchList])


    const columnGroupingModel = [
        {
            groupId: 'Products',
            children: [{ field: 'id' }, { field: 'product' }, { field: 'unit_type' }],
        },
        ...branchList.map(branch => ({
            groupId: branch.branch_name,
            children: [
                { field: 'branch_buffer_' + branch.branch_id },
                { field: 'branch_active_' + branch.branch_id },
            ]
        }))
    ];

    const apiRef = useGridApiRef()

    async function onCeilEdit(param) {
        setTimeout(() => {
            let row = apiRef.current.getRowWithUpdatedValues(param.id)
            const max_stock = row[param.field]
            const data = {
                product: +row.id,
                branch: +param.field.split('_')[2],
                max_stock
            }

            if (typeof max_stock === 'number') {
                setError(null)
                dispatch(updateProductBranchAction(data))
            } else {
                setError('Enter valid value (only numeric)')
            }

        }, 100)
    }

    return (
        <Box sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 4,
                padding: '15px 0px'
            }}>
                <Typography variant="h3">{t('page_text.buffer_manager')}</Typography>
                {error && <Typography sx={{ color: 'red' }}>{error}</Typography>}
                <Box component='form' sx={{
                    display: 'flex',
                    gap: 3
                }}>
                    <FormControl sx={{ width: '250px' }}>
                        <InputLabel id="branch_type">{t('label.branch_type')}</InputLabel>
                        <Select
                            defaultValue={selectedTypeBranch}
                            disabled={dataLoad}
                            labelId="branch_type"
                            label={t('label.branch_type')}
                            onChange={(e) => dispatch(setTypeBranch(e.target.value))}
                            required
                        >
                            <MenuItem value={1}>{t('label.kitchen')}</MenuItem>
                            <MenuItem value={2}>{t('label.branch')}</MenuItem>
                        </Select>
                    </FormControl>

                    {selectedTypeBranch !== 1 ?
                        <FormControl sx={{ width: '250px' }}>
                            <InputLabel id="category">{t('label.category')}</InputLabel>
                            <Select
                                defaultValue={selectedCategory}
                                disabled={dataLoad}
                                ref={apiRef}
                                labelId="category"
                                label={t('label.category')}
                                onChange={(e) => dispatch(setCategory(e.target.value))}
                                required
                            >
                                {categoryList.map((category) =>
                                    <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        : 
                        <FormControl sx={{ width: '250px' }}>
                            <InputLabel id="category">{t('label.kitchen')}</InputLabel>
                            <Select
                                defaultValue={selectedCategory}
                                disabled={dataLoad}
                                ref={apiRef}
                                labelId="category"
                                label={t('label.category')}
                                onChange={(e) => dispatch(setCategory(e.target.value))}
                                required
                            >
                                {kitchenList.map((branch) =>
                                    <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                </Box>
            </Box>
            <Box sx={{
                height: '100%'
            }}>
            <DataGridFullScreen
                loading={dataLoad || dataUpdate}
                columns={columns}
                apiRef={apiRef}
                rows={rows}
                columnGroupingModel={columnGroupingModel}
                showCellVerticalBorder
                onCellEditStop={onCeilEdit}
            />
            </Box>
        </Box>
    )
}

export default ProductsBufferPage